import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function Login() {
  const [codigo, setCodigo] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!codigo || !senha) {
      setErro("Preencha todos os campos");
      return;
    }

    try {
      const systemType = process.env.REACT_APP_SYSTEM_TYPE || "viva";
      const baseURL = process.env.REACT_APP_API_URL;

      let endpoint = "";
      let axiosConfig = {};
      let res;

      if (systemType === "viva") {
        endpoint = `${baseURL}/v16_view/controller/controller.php`;
        axiosConfig = {
          params: {
            p1: "pegaAcessoPaciente",
            p2: codigo,
            p3: senha,
            empresa: 13,
          },
        };
        res = await axios.get(endpoint, axiosConfig);

      } else if (systemType === "synclab") {
        endpoint = `${baseURL}/app/pegaacessopaciente/${codigo}/${senha}`;
        axiosConfig = {
          auth: {
            username: "sync-oct",
            password: "d74e50bc-0d39-3dc5-8fe3-160ecea0944c",
          },
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          withCredentials: false, // garante que o axios não tente enviar cookies
        };

        res = await axios.get(endpoint, axiosConfig);
      }
      else {
        throw new Error("SYSTEM_TYPE inválido");
      }

      console.log("Resposta da API:", res.data);

      const nome = res.data?.ato_nome || res.data?.nome || res.data?.name;
      if (nome && nome.trim() !== "") {
        localStorage.setItem(
          "paciente",
          JSON.stringify({ nome, codigo })
        );
        navigate("/exames");
      } else {
        setErro("Código ou senha inválidos.");
      }
    } catch (error) {
      console.error(error);
      setErro("Erro ao conectar com o servidor.");
    }
  };


  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div className="card shadow p-4" style={{ width: "100%", maxWidth: "400px" }}>
        <div className="text-center mb-4">
          <img
            src="https://viva.octussistemas.com.br/dist/img/logo_azul.png"
            alt="Viva"
            style={{ width: "150px", marginBottom: "15px" }}
          />
          <h4 className="mt-2">Área do Paciente</h4>
          <p className="text-muted">Acesse seus exames</p>
        </div>

        <div className="mb-3">
          <label className="form-label">Código de Acesso</label>
          <input
            type="text"
            className="form-control"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            placeholder="Ex: 000000"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Senha</label>
          <input
            type="password"
            className="form-control"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="Ex: 00000000000"
          />
        </div>

        <button className="btn btn-primary w-100" onClick={handleLogin}>
          Entrar
        </button>

        {erro && <div className="alert alert-danger mt-3">{erro}</div>}
      </div>
    </div>
  );
}
